import { type FC, type SyntheticEvent } from 'react';

import { TransportIcon } from '@/packages/shared-ui/components/TransportIcon';
import { extractUndefined } from '@/packages/utils/extractUndefined';

import { type ITransportSchema } from '@/repositories/generated/shared/search-offers/entities/geo/TransportSchema';

import { RemotenessIcon } from '../RemotenessIcon';
import { SpecialGeo } from '../SpecialGeo';

import styles from './SpecialGeoList.css';

type SpecialGeoListProps = {
  transports: Array<ITransportSchema>;
  onClick?(event: SyntheticEvent<HTMLElement>, transport: ITransportSchema): void;
  trackClick(): void;
};

export const SpecialGeoList: FC<SpecialGeoListProps> = props => {
  const { transports, onClick, trackClick } = props;

  if (!transports.length) {
    return null;
  }

  const handleClick =
    (transport: ITransportSchema) =>
    (event: SyntheticEvent<HTMLElement>): void => {
      onClick?.(event, transport);
    };

  return (
    <div className={styles['container']}>
      {transports.map(transport => {
        return (
          <SpecialGeo
            icon={<TransportIcon iconColor={extractUndefined(transport.iconColor)} iconType={transport.iconType} />}
            key={transport.id}
            name={transport.name}
            remoteness={transport.remoteness}
            remotenessIcon={!!transport.remotenessType && <RemotenessIcon iconType={transport.remotenessType} />}
            trackClick={trackClick}
            url={transport.offersUrl}
            onClick={handleClick(transport)}
          />
        );
      })}
    </div>
  );
};
